import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RapportIncidentTypeIncident, RapportIncidentTypeIncidentDetail } from 'src/api/models';

@Component({
  selector: 'app-rapport-incident-type-detail-select',
  templateUrl: './rapport-incident-type-detail-select.component.html',
  styleUrls: ['./rapport-incident-type-detail-select.component.css']
})
export class RapportIncidentTypeDetailSelectComponent implements OnInit {
  @Input() public id: number;
  @Output() idChange = new EventEmitter<number>();
  @Input() width: number;
  @Input() cell: any;
  @Input() typeIncident: RapportIncidentTypeIncident;
  @Input() typeIncidentDetails: any[];

  @Input() disabled: boolean = false;

  constructor() { }

  ngOnInit(): void {    
  }

  valueChanged(e) {
    if (!!this.cell) {
      this.cell.setValue(this.id);
    }    

    this.idChange.emit(this.id);
  }  
}
